"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _wrapper = _interopRequireDefault(require("./wrapper"));

var _colors = require("../../../../styles/colors");

function _templateObject() {
  var data = (0, _taggedTemplateLiteral2["default"])(["\n    align-items: center;\n    display: flex;\n    padding: 0 15px;\n    border: 1px solid ", ";\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var StyledCheckboxWrapper = (0, _styledComponents["default"])(_wrapper["default"])(_templateObject(), _colors.COLOR_GRAY_1);
var _default = StyledCheckboxWrapper;
exports["default"] = _default;